import useStore from '../store';
import { USER_MESSAGE_TYPES } from '../flows/UserMessageFlow/constants';
import { RenderNaicsModal } from '../flows/changeNaics/ChangeNaics';

export const DASHBOARD_MODAL_SHOWN_KEY = 'DASHBOARD_MODAL_SHOWN_KEY';
export enum GlobalModals {
  NAICS_INDUSTRY_UPDATE,
}

const modalToTemplateMap = {
  [GlobalModals.NAICS_INDUSTRY_UPDATE]: <RenderNaicsModal />,
};

export const useGlobalModalsManager = () => {
  const actionFlags = useStore((state) => state.summary?.actionFlags);
  const { setMessageObject } = useStore((state) => state);

  const showModal = (modal: GlobalModals) => {
    setMessageObject({
      type: USER_MESSAGE_TYPES.USER_MESSAGE,
      customModal: modalToTemplateMap[modal],
    });
  };

  const checkModalConditions = async () => {
    const modalConditions = {
      [GlobalModals.NAICS_INDUSTRY_UPDATE]: () => actionFlags?.needUpdateNaicsCode,
      // Add other modal conditions here
    };

    const checkConditions = async () => {
      // eslint-disable-next-line no-restricted-syntax
      for (const modal of Object.values(GlobalModals)) {
        if (modalConditions[modal as GlobalModals]) {
          // eslint-disable-next-line no-await-in-loop
          const shouldPresent = await modalConditions[modal as GlobalModals]();
          if (shouldPresent) {
            showModal(modal as GlobalModals);
            break;
          }
        }
      }
    };

    await checkConditions();
  };

  const triggerModalLogic = () => {
    if (actionFlags) {
      checkModalConditions();
    }
  };
  return {
    triggerModalLogic,
  };
};
